import { useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { queryKeys } from '@/queries/query-keys';
import { useAuthStore } from '@/stores/auth-store';

/** POST `/org` — account bootstrap + organization row (NewAccountRequest). */
export function useCreateOrgMutation() {
  const queryClient = useQueryClient();

  return useApiMutation(
    () => '/org',
    'post',
    {},
    {
      onSuccess: (data) => {
        useAuthStore.getState().setSession(data);
        queryClient.invalidateQueries({ queryKey: queryKeys.session() });
        NotificationManager.success('Account created', '', 3000);
      },
      onError: (err) => {
        NotificationManager.error(
          err.message || 'Could not create account',
          '',
          4000,
        );
      },
    },
    (values) => {
      const email = values.accountName.trim();
      const website = values.websiteAddress?.trim();
      const phone = values.phoneNumber?.trim();

      return {
        accountName: email,
        password: values.password,
        firstName: values.firstName.trim(),
        lastName: values.lastName.trim(),
        phoneNumber: phone || null,
        orgName: values.orgName.trim(),
        /** Org contact email — design uses a single user email; mirrors login identity. */
        emailAddress: email,
        websiteAddress: website || null,
        accountPhoto: null,
        orgPhoto: null,
      };
    },
  );
}
